import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/icons/editDoc.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_PrintDocumentDialog = _resolveComponent("PrintDocumentDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_q_btn, {
      class: "badge-danger btn tw-document-trigger-btn",
      disable: _ctx.printBlocked,
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleShowControls())),
      floating: ""
    }, {
      default: _withCtx(() => [
        _hoisted_1,
        _createVNode(_component_q_tooltip, null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.printBlocked ? _ctx.$t("order.tooltip.printOrderNotStarted") : _ctx.$t("order.tooltip.print")), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["disable"]),
    _createVNode(_component_PrintDocumentDialog)
  ], 64))
}